// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fVmUk","icon":"styles_icon__VS-Qo","text":"styles_text__d2yni"};